export enum SupportTopic {
  GENERAL_QUESTION = 'GENERAL_QUESTION',
  TECHNICAL_ISSUE = 'TECHNICAL_ISSUE',
  INTEREST_IN_PRODUCT = 'INTEREST_IN_PRODUCT',
}

export const SupportTopicWithProductNeed = [SupportTopic.INTEREST_IN_PRODUCT, SupportTopic.TECHNICAL_ISSUE];
